module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "بعد-أسابيع"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعدَ أسابيع")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تتوقَّع \"حياة\" من أمِّها ذلك الهدوء في التّعامل بعد تركِها للدّراسة في إسطنبول ورجوعها للبلد وحيدةً كلَّ تلك المسافة وتعريضِ نفسِها للخطر، ولم تفهم السَّبب وراء سُكوتِها كلَّ ذلك الوقت واكتفائها بعقابِ المقاطَعة والحَجرِ المنزليّ.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تظنّي بأنَّني غاضبٌ مِنك بسبب ترككِ الدّراسة في تركيا يا حياة، أنا فقط مُتفاجئٌ من تهوُّرك وعدم اكتراثك لعواقِب قراراتكِ غير المسؤولةِ، بسببك عِشْنا أيّامًا عصيبةً كلّها خوفٌ وقَلَقٌ من مصيركِ وما قد تواجِهينه من مخاطرٍ في طريق السَّفر، لم أتوقَّع منكِ هذا يا بنتي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّت حياة بحزنٍ: آسفةٌ يا أبي، لكن لو لم تُجبرني أمّي لما..")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: هذا العُذر غير مقبولٍ أبدًا، لا شيءَ يغفر لكِ ما فعلْتِه.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أبي مَهْما كان ذنبي لا يغتفر، لا يمكنكم أن تُعاقبوني بالزّواج من شخصٍ أحمقٍ وغبيٍّ مثل مشعان.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("القَرار الأوَّل والأخير في هذا الموضوع عند والدتك.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دَعْكَ منّي ومن أمّي، الآن قُلْ، هل ترضى أن يكونَ صِهْرك الوحيد -بما إنَّني ابنتك الوحيدةُ- شخصًا مثل مشعان؟ تخيّل نفسكَ وأنت السيّد فاضل السَّعيد المُحترم! هل يُعقَل أن يكون صهرُك مشعان؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا فائدة الآن، أمّك قرَّرت وانتهى الموضوع.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أبي!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا أستطيع فِعْل شيءٍ من أجلك، إنَّها أوامرٌ عُلْيا وغير قابلةٍ للنِّقاش.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتتخلّى عنّي بهذه السّهولة؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("آسفٌ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أبي!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بما أنَّ العمّ مالك وعليّ سيأتيان اللَّيلة لتناوُلِ العشاء، توسّط لي عِندها لتسمح لي أن أنضمَّ إليكم، في المرَّة السّابقة لم تسمَح لي!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا بأس، سأحاول.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يكن \"مالك\" يغيب عن منزل السيّد فاضل أكثر من أسبوعٍ، ولكنَّ الوضع اختلف في الفترة الأخيرة، فقد غاب عنهم شهرًا كاملًا ممَّا جعل الجميع يشتاق إليه دون استثناءٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- نسيتَنا تمامًا منذُ أن قَدِم عليّ وأصحابه يا أستاذ مالِك، ولم تَعُد تزورنا إلّا بدعوةٍ رسميَّةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ مالك: آسفٌ، انشغلتُ بهم قليلًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: انشغلْتَ بِهِمْ أم بعائلتك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: آه يا فاضل، لا أدري كيف تركتها تأخذُهم منّي؟! لقد كبروا بعيدًا عن عيني ولا أعرف شيئًا عن حياتهم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: لم يكن عليكَ أن تستسلم لشروطِها منذ البِداية وتتركها تأخذ أولادك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: كيف أستسلم وأنا لم أُقاتِل من أجلِهم من الأساس، لقد فكَّرتُ في نفسي فقط، أولادي لم يستحِقّوا منّي هذا.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سيسامحك أولادك يا مالك، لا تقلق إنّها مسألةُ وقتٍ، وهذه فُرصتك بعد أن استقرُّوا هنا، حاوِل أن تتقرَّب مِنهم.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتوقَّع من \"مَجْد\" أن يلين قلبه ناحِيتي ويُسامحني في يومٍ ما، لكن \"سَجَى\" من المُستحيل أن تفعل يا فاضِل.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد عدَّة مُحاولاتٍ قَبِلت التحدُّث معي، جلستُ معها وتحدَّثتُ وشرحتُ لها ما حدَث واعتذرتُ وطلبتُ مِنها أن تُسامحني.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هذا جيّد.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالت إنَّها ستُسامِحني.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في البداية قلتُ بأنَّها من المُستحيل أن تسامِحك، والآن تقول إنّها سوف تسامِحك، ما لك؟! أنا لم أفهم شيئًا.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ستُسامِحني لكن قبل ذلك يجب أن أنسى بأنَّني رُزِقت بابنةٍ في يومٍ من الأيّام، وأن أحاول قَدْر المُستطاعِ ألّا أَظْهر أمامَها لأنَّها تكره أن تراني، هذا شرطُها.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تحزن، \"سَجَى\" ما زالت صغيرةً ولا تعرف ماذا تقول.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قبلَ أن يُنهي السيّد فاضل جُملته تقتحم حياة غرفة المكتب:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتَ هنا وأنا أبحثُ عنك في الخارج!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: ماذا هناك يا حياة؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: اقتحامُكِ للمكتب بهذه الطَّريقةِ يجب أن يكونَ وراءه مُصيبة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حياة: عليٌّ سيُغادر دون تناول العشاء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\"هكذا! وبدون سبب سيغادر دون تناول العشاء، لمَن أعددتُ هذه الوليمة؟ قال السيد فاضل وخرج من المكتب باتّجاه الصّالةِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("همّتْ حياة بالخروج من غرفة المكتبِ لتلحق بوالدِها لكنَّ مالكًا استوقفها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كلُّ هذا لأنَّ عليًّا سيغادر دون تناول العشاء!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ارتبكَتْ ولم تُقُلْ شيئًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أصبحَتْ دعوة العشاء مصدرَ إزعاجٍ لعليّ بعد أن قامَت السيّدة فخريّة بتقديم مِشعان بصفتهِ الصّهر المستقبليُّ للعائلةِ.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لستَ وحدك المُنزعِج من وجوده! قال \"ناظم\" شقيق \"حياة\" الأوسط.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظر إليه عليّ بدهشة واستغراب دون كلام.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا مثلك يا بن عمّتي لا أطيقه؛ تافِهٌ وسَطْحيّ! كلُّ كلامه عمَا يملكه والِده من أملاكٍ وسيّارات، الغبيّ يظنُّ بأنّنا نُصدِّق قصة تخرُّجهِ من أوكسفورد!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: لا تظلمه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ناظِم مشيرًا بيده ناحية مشعان:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هذا الّذي تراه يَتباهى علينا بدراسته في بريطانيا، أتعرف بأنَّه مطرودٌ من الجامعةِ وشهادته مزورة؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: أَنزِلْ يدَكَ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ناظِم: لكن لا تقلق! لا يعرف حتّى الآن أنّكَ مُلاحَقٌ، حتّى الآن على الأقلِّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: جيد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("همَسَ عليّ بينه وبين نفسه: وكأنَّ هذا ما يزعجُني حقًّا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ناظِم: ماذا قلتَ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: لا شيء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ناظِم: لا بأسَ إنْ لم تخبرني، لكن انظرْ مَن القادمُ! وبالطّبع يريد تبريرًا لقرارك المفاجئ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: عليّ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردَّ عليّ: نعم يا خال!")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما هذا الذي سمعتهُ مِن حياة؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا مُرْهقٌ قليلًا يا خال..")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطَعه فاضل: مرهقٌ! بسبب أعمال المزرعة، صح!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ مبتسمًا: نعم، لقد استعبَدنا ابن عمّك تمامًا، قُلْ له أن يخِفّ علينا قليلًا لم نعد نحتمل يا خال!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان حامدٌ بالقرب منهم وسَمِع حديثهم وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اسألني أنا عن العمّ مالِك، فأنت لم تُجرّب العمل في المزرعة كعقابٍ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ عليه فاضل: لو كنتَ ولدًا مطيعًا لما عاقبتُك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حامد: وماذا عن ناظِم أفندي؟! ما الّذي يشفع له كي لا يُعاقَبَ مِثْلنا؟! أدبُه أم تفوُّقه في الدراسة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: أنتَ وأخوتُك التوءَم كنتم عصابة، أمّا ولدي هذا -مشيرًا إلى ناظم- مؤدَّب ومُطيع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حامد: ابنك فقط يجيد إخفاء بلاياه عنكَ ومسح آثارها!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: وهذا هو المطلوب، ولهذا دائمًا كان \"ناظم\" المفضّل لديَّ؛ لأنّه أَذْكى منكم!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقدّم مشعان ناحيتهم حتّى أصبح بالقرب من حياة وقال: وحياة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظَر إليها فاضل وقال: أمّا هذهِ فهي أميرةُ قلبي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطعَت السيّدة فخريّة حديثهم: العشاءُ جاهِزٌ، تفضّلوا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وما إنْ جلس الجميع لتناول الطعام حتّى فتحَت فخريّة موضوعَ دراسة مِشعان في أوروبّا وجولاتِه حول العالَم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: ماذا كان مجال دراستك يا مشعان؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ مشعان: درستُ الهندسة المعماريّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أضافَت فخريّة: وسيدير مكتبَ والده في المستقبل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حياة: ولماذا ليس الآن بما أنّك عاطلٌ لا عَمَل لك سوى التسكُّع؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرت فخريّة إلى حياة بغضبٍ، ثمّ التفتت إلى عليّ وقالت: وأنتَ يا عليّ، متى ستُنهي دراستكَ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ عليٌّ: \"ما زلت في بدايةِ حياتي الجامعيّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فخريّة: اتركِ الفوضى وتعلّم كيف تنظّمُ حياتَك يا عليّ، انظرْ إلى مشعان، فقد أَنْهى سنواتِه الدراسيّة بنجاحٍ وحقّق حلمَه بالسّفر حول العالَم، والآن سيعملُ في مَكتب والده، وقريبًا سيتزوج ويؤسّس عائلةً، هو مثالٌ للشّاب الطَّمُوح والمُجتهد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ بعد أن التقطَ نظرةَ ناظِم الخاطفة وابتسامته السّاخرة قالَ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- طبعًا، طبعًا هو كذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فخريّة لعليّ: ألا تعتقدُ بأنّهما يُشكِّلان ثنائيًّا مُميَّزًا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ عليّ: حياة لا تحتاج لشخصٍ مثل مشعان لتصبح مُميزّةً، هي فعلًا مُميَّزةٌ يا سيّدة فخريّة، ولا أقول هذا لأنّها ابنةُ خالي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فخريّة: مشعان كذلك شابٌّ مميّز!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: ما الّذي يميزّه غير أموال والده؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حاولَتِ السيّدة فخريّة إيجادَ ميزةٍ في مشعان لكنّها عجزت، فهي كانَت تراهُ مُميَّزًا بسبب ما يملكُه والده من ثروة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظلّ عليٌ ينتظر جوابها فترة، ثمَّ نهضَ: عن إِذْنكم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: ليس قبل أن تتناول الحلوى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ثمّ التفت إلى ابنتهِ قائلًا: حياة، هلّا قدَّمْتِ الحلوى!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: أشعر بالنّعاس، علَيَّ العودة إلى المزرعة، غدًا ينتظرني يومُ عملٍ شاقّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: هذه الحلوى أعدَّتْها ابنتي العزيزة، لا يمكنكَ أن تفوّتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: في زيارةٍ أخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ناظِم: سآخُذ نصيبَ عليّ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: بالعافية يا بن خالي! قال عليٌّ هذا ثمَّ نظرَ إلى العمّ مالك وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ألن تأتي معي؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مالك: أنتَ عليك الاستيقاظ باكرًا لتنظيف الإسطبل، وليس أنا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فاضل: أهكذا تعاملُ ابن أختي الوحيد يا مالك؟ تجعله ينظِّف إسطبل خيولك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردّ عليه مالك وأكمل تناوُل طعامه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسمَ عليّ وقال: تصبحون على خير. ثمَّ انصرف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظلّتْ حياة تراقبه حتَّى خرج من غرفة الطّعام وغادر المنزل، وضعَت حياة الطّبَق الّذي فيه حِصّة عليٍّ من الحلوى أمام ناظِم بسرعةٍ وتوجّهت لغرفتها، وفتحَت السّتارة، وظلّت تراقبهُ إلى أن اختفى تمامًا في الظّلام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رَجَع إلى المزرعة ودخل إلى الإسطبل ليتفقّد فَرَسه الّتي وهَبها له مالِك، ثمّ بهدوءٍ دخل إلى البيت، وانتبه إلى النُّور المُضاءِ في غرفة المكتب، فتح البابَ، وقالَ: رشيد!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التفتَ رشيدٌ وقال: عدتُما!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ عليّ: رجعتُ لوحدي. قال عليّ هذا ثمَّ توجّه نحو المكتبِ وسحب الكرسيَّ، وجلسَ أمام رشيدٍ، وسألهُ: ما بِكَ؟")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا شيءَ!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كلَّا، هناك شيء، لستَ \"رشيد\" الذي تركتُه قبل ساعاتٍ قليلةٍ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كذلك أنت، لم تَعد بالوَجْه الَّذي ذهبتَ به.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتّ قليلًا ثم رجَع بظهره إلى الخلف وقال: حياة يا رشيد.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما بها؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظر في عَيْنيّ رشيد وقال: حاولتُ كثيرًا أن أُخرجها من عقلي وتفكيري لكنّني لم أقْدِر، أعتقد بأنّني أحبّها.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما الجديد؟ كان هذا واضحًا من نظراتك عندما رأيتكَ معها أوّل مرَّةٍ في المحطّة.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعرف يا صديقي، أنا سعيدٌ جدًّا بانسياقي وراء هذه المشاعر، ولا يهمّني إلى أيّ حدٍّ يمكنني الوصول.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لأنَّك عاشق.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صمتَ قليلًا وقال: هل سيعاقبني الله على ما فعلتهُ بعلياء يا رشيد؟")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم أَفْهم منذ البداية سبب ارتباطِك بعلياء وأنت لا تكنُّ لها أيَّة مشاعر!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كيف عرفت بأنّني لا أُحبّها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كلُّ شيءٍ فيك كان يدلّ على أنَّك لا تحبّها؛ تصرفاتك معها، بُرودك، حتّى نظراتُك لها، كلُّ شيءٍ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنَّها تنتظرني هناك على أمل أن أذهب إلى جدّها وأخطبها، ماذا أفعل؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أَنْهِ الموضوعَ.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فكَّر قليلًا وقال: نعم، يجب أن أذهب إلى العاصمة وأُنْهي الموضوع.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أجننتَ؟! سيُقبض عليك، لا داعي أن تذهب بنفسكَ إلى هُناك.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا أفعل إذًا؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لمَ لا تكتب رسالةً تشرح فيها كلَّ شيءٍ، وترسلها مع نَصْرت أو عِزّت؟ فلا خوف عليهما لأنّهما غير مطلوبَيْن.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رسالة! لا، لا، من الأفضل أن أذهب بنفسي.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("زفَر رشيد ورجَع للخلف مُغْمِضًا عينيه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: وأنتَ، ما سبب حالك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردّ لكن عليّ فَهِم الأمر، وقالَ لهُ: هل اعترفتَ لها بحبّك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بحُزنٍ هَزَّ رأسه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: لا تحزن، هذا من صالحك، ماذا كنت ستقول لعائلتك، ولزوجتكَ؟ والأهمّ من كلّ ذلك لوالدك! هل كان سيسمح لكَ بأن تُفْسد علاقته مع حَماك أكثر؟ فكّر بالأمر جيّدًا يا رشيد.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنتَ تقول هذا! ظننتُ أنَّك الوحيد الَّذي سيفهمني بعد أن أصبحتَ عاشِقًا!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أفهمكَ لكن، ماذا ستفعل إذا عَلِم أبوك؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لن أدعه يُفسِد حياتي مرّةً أُخرى.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لن تستطيع مواجهة كمال الرشيد.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لن أدعه يحرمني من السّعادة، كما حرمني من مِهْنتي! سدّ كلَّ الأبواب في وَجْهي، سلّط عليَّ مَعارِفه وأصدقاءه، ولولا العمُّ ناجي الَّذي وظَّفني في مَكْتبته وأَسْكنني في بَيْته لكنتُ مُشرّدًا الآن.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وهذا ما قَصدتُه، تذكّر جيّدًا ما فعله بذلك الشّاب الَّذي كان يحبُّ شقيقتك، ما كان اسمه؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظمي.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ألا تخاف على سعاد من رَدّة فِعله وهي امرأةٌ وحيدةٌ؟ حَتْمًا سيُؤذيها.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتظنُّ بأنّي سأتركه يؤذيها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رشيد يجب أن تفكّر في سعاد.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قلتُ لك إنّه عدوّي وليس أبي، ظننتَ بأنّني أُبالِغ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ألَا تظنُّ أنّك تسرَّعْتَ في موضوع سعاد؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قد أكون تسرَّعتُ، لكن أنت، ما أسبابك لتأخير اعترافك لحياة بحبّك؟ لماذا لا تُنْهي الأمر وتعترفُ لها؟")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ عليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رشيد: مُتردِّد!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: أتظنُّ بأنَّ حياة تحبّني؟")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("*****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَن يَراه واقِفًا خَلْف المَصْطبة يظنُّ أنّه يُراقب الخُيول من بَعيدٍ، ولكنّ شُرودَه دَليلٌ أنّ عقله في مكانٍ آخرٍ تمامًا، يُشعل سيجارةً ويتركها تحترق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هل لاحظتَ أنّكَ أنهيتَ العُلبة؟ "), _c('strong', [_vm._v("قال رشيد")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اكتفى عليّ بابتسامةٍ، ثمَّ سحب نفَسًا من السّيجارة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رشيد: ما الَّذي قاله لك حتّى انقلب حالك هكذا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- مَن؟ عزّام!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اكتفى رَشِيد بهزّ رأسه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قال علي مُبتسمًا: تخيّل! اتَّصل ليسألَ عن عُنوان نجيّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ رشيد باستغرابٍ: مَن نجيّة؟ لا تقل المغنّية!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يجب عليّ واكتفى بالابتسامة وهو ينظر إلى رشيد.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما الَّذي يُريده عزّام منها؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا أدري.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بخُبثٍ سأل رشيد: وما أدراكَ أنت بعنوان بيتها؟")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تذهب بتفكيركَ بعيدًا.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اشرح لي إذًا.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حصل كلُّ شيءٍ صُدفةً.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رشيد: صُدفة!")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تنظر إليّ هكذا، أتَذكُر ذلك اليوم الماطر عندما كنّا مُلاحَقين من رجال الأمن؟ دخلتَ أنت قهوة أبي عامر، وعزّام اختبأ في شاحنة الخُضار.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نعم، نعم تذكّرتُ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في ذلك اليوم بعد أن تفرّقنا دخلتُ إلى إحدى المباني القديمة في أحد الأحياء، وصعدتُ الدّرَج بسرعةٍ، اصطدمتُ بامرأة كانت تقف عند باب شقّتها تحاول فتح الباب، عندما نظرتُ إليها وإذا بها نجيّة! عرَفتْ أنّني مُلاحَقٌ وخبّأتني في منزلها.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هذا فقط، لا يوجد شيءٌ آخر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فتَح عليّ عينيه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رشيد: حسنًا، حسنًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ: الغريب..")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطعَه رشيد: آها، أخبِرني، ما الغريب؟")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا شيء، الغريبُ أنَّ مَظْهرها لا يدلُّ أنّها فقيرةٌ؛ فهي تركب أحدث السيّارات، وتتزيّن بأغلى المُجوهرات، وترتدي أفخم الفساتين، كيف تعيش في منطقةٍ فقيرةٍ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأغربُ هو، ماذا يريد عزّام من نجيّة؟! بدأت أشكّ بصاحِبك هذا.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عليّ بينه وبين نفسه: آه يا رشيد! ليتكَ تعرف قصّتها.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتعرف يا علي؟! وكأنّني أعرف نجيّة هذه من قَبْل، رأيتها في مكانٍ ما، لكن متى؟ وأين بالتَّحديد؟! لا أَذْكر.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تقصد مكانًا غير الملهى!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نعم، المهمّ الآن، قُلْ لحازم عندما يرجع من المسرح، ألّا ينسى تنظيف الحظيرة، اليوم دَوْره في التَّنظيف.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد أن أنهى رشيد إصدار أوامره همّ بالمغادرة.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى أين؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التفت إلى عليّ دون أن يتوقّف وعلى وجهه ابتسامةٌ، ثمَّ لوَّح بيده وتابَع طريقه نحو مزرعة سعاد، \"غبيّ\" قالها عليّ وهو يُراقب رشيد")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حتّى أصبح خارج مزرعة مالك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظنّت سعاد أنّ الأمر انتهى عندما أخبرته أنَّ الأمل في هذا الحبِّ معدوم، لكنَّ إصرار رشيد كان أكبر من كلِّ شيء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سعاد: ما الَّذي تُحاول فعله يا رشيد؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يُجب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالت: أنت تُحرِجني بتصرّفاتك، ماذا سيقول عنّي النّاس؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ رشيد: سيقولون ما يرونه، عاشِقك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سعاد: تتعمَّد فِعل هذا لتُحرجني أليس كذلك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سعاد: تنتقم منّي يا رشيد بهذه الطّريقة؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رشيد: أنا انتقم منك يا سعاد؟ أنا أحبّك، لماذا لا تُريدين أن تفهَمي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنت من يجب عليه أن يفهم...")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قاطَعها: لا أريد أن أَفْهم، لا أستطيع أن أَفْهم، أنتِ لا تعرفين ماذا تعنين لي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تتعلّق بي أكثر يا رشيد، ستتألّم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وكأنَّكِ تطلبين منّي ألّا أتنفّس!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنا لا أشعر بشيءٍ اتّجاهك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تقولي هذا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا أناسبك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنا أقرّر يا سعاد، فقط أنا يحقّ لي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وأنا أيضًا يحقّ لي أن أقرّر يا رشيد!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالتْ جُملتها وانصرفَت، لكنَّ سؤال رشيد فاجأها فتوقَّفت مكانها دون أن تلتفت إليه.")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل هوَ ذلك الرّجل الَّذي أحببتِه وتركَك؟ هو من تحبّين بالرّغم من أنّه دمّر حياتك وكان السّبب بحرمان ابنك من والده؟ هل يستحقّ مثله أن تُفني عمركِ كلّه من أجلهِ يا سعاد؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مشى حتّى أصبح أمامها وقال: ما زلتِ تُحبينه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("زفَرَت سعاد بحُرقةٍ واستجمعت نفسها بصعوبةٍ بَعْد الَّذي سمِعَتْه من رشيد ثمَّ قالت:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ما زلتُ أحبّه، عرفت الآن لماذا لا أستطيعُ أن أحبّك؟! لأنّني أيضًا عاشقة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c3393e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch017.vue
// module id = 111
// module chunks = 0